import {Component, EventEmitter, Inject, OnInit, Output, ViewChild} from '@angular/core';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';

@Component({
  selector: 'storever-status-to-off',
  templateUrl: './status-to-off.component.html',
  styleUrls: ['./status-to-off.component.scss']
})
export class StatusToOffComponent  implements OnInit {

  @ViewChild('staticModal', {static: false}) public staticModal: ModalDirective;
  @Output() _send = new EventEmitter<boolean>();

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale) {
  }

  ngOnInit(): void {
  }

  send(): void {
    this._send.emit(true);
    this.close();
  }
  close(): void {
    this._send.emit(false);
    this.staticModal.hide();
  }

  open(): void {
    this.staticModal.show();
  }

}
